import { ScheduleManagementPage } from "../../../components/schedule/ScheduleManagementPage";

export function StaffSchedulePage() {
  return <ScheduleManagementPage role="staff" />;
}
